import React from 'react';

const index = () => {
  return (
    <div className="flex flex-col w-full px-5 py-8 border xs:px-10 sm:px-16 bg-grey-200 border-grey-400 dark:bg-blue-1000 dark:border-grey-700 rounded-xl">
      <div className="flex flex-col max-w-2xl dark:text-blue-100">
        <h2 className="text-2xl text-left text-red-600 dark:text-red-400">404 Not Found</h2>
        <p className="mb-5">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Tenetur delectus sit eaque sint
          adipisci! Consequuntur beatae ipsum ducimus molestias natus.
        </p>
      </div>
    </div>
  );
};

export default index;
